const dealFilters = {
  dealAssignmentType: null,
  dealClientName: null,
  consultantName: null,
  jobTitle: null,
  createdBy: null,
  statusId: null
}

export default () => Object.assign({}, dealFilters)
